<div class="m-b-20">

    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{attribute.attr_label}}
                </mat-panel-title>

            </mat-expansion-panel-header>

            <ul >
                <li *ngFor="let option of options">
                    <div class="d-flex">
                        <div class="p-2"><mat-checkbox #c name="{{option.option_label}}" (change)="checkBoxSelected(option.option_id , attribute.attr_id )" i18n>{{option.option_label }}</mat-checkbox></div>
                        <div class="ml-auto p-2 m-t-5">
<!--                            <label class="badge badge-info">{{option.option_id }}</label>-->
                        </div>
                    </div>

                </li>
<!--                <li>-->
<!--                    <div class="d-flex">-->
<!--                        <div class="p-2"><mat-checkbox name="n2" (change)="checkBoxSelected()" i18n>Brand2</mat-checkbox></div>-->
<!--                        <div class="ml-auto p-2 m-t-5"><label class="badge badge-info">20</label></div>-->
<!--                    </div>-->

<!--                </li>-->
<!--                <li>-->
<!--                    <div class="d-flex">-->
<!--                        <div class="p-2"><mat-checkbox name="n3" (change)="checkBoxSelected()" i18n>Brand2</mat-checkbox></div>-->
<!--                        <div class="ml-auto p-2 m-t-5"><label class="badge badge-info">20</label></div>-->
<!--                    </div>-->

<!--                </li>-->

            </ul>

        </mat-expansion-panel>
    </mat-accordion>
</div>

